/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import useCustomerActions from '@/composables/api/useCustomerActions';
import {
 trackCustomer, trackOrderKey, trackAction, trackCustomProperty,
} from '@/composables/tracking/useTracking';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

export const useTrackingStore = defineStore({
  id: 'tracking',
  state: () => ({
    orderKey: null,
    customerKey: null,
    // array of objects { actionName: string, payload: object }
    actions: [
    //   {
    //   actionName: 'ORDER_CREATION',
    //   payload: {currency: 'USD'},
    // }
    ],
    // array of objects { customName: string, payload: object }
    customProperties: {},
  }),
  actions: {
    async recordCustomer() {
      if (this.customerKey) {
        return;
      }

      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        this.customerKey = await useCustomerActions().fetchCustomerId();
        trackCustomer(this.customerKey);
      } catch (error) { }
    },
    recordOrderKey(orderKey) {
      if (!orderKey || this.orderKey) {
        return;
      }

      this.orderKey = orderKey;
      trackOrderKey(this.orderKey);
    },
    recordAction(actionName, payload = {}) {
      if (!actionName || typeof actionName !== 'string') {
        return;
      }

      const capitalizedActionName = actionName.toUpperCase();

      this.actions.push({ actionName: capitalizedActionName, payload });
      trackAction(capitalizedActionName, payload);
    },

    setCustomProperty(customName, payload = {}) {
      if (!customName || typeof customName !== 'string') {
        return;
      }

      this.customProperties[customName] = payload;

      trackCustomProperty(customName, payload);
    },

    recordOrderProperties() {
      Object.keys(this.getOrderProperties).forEach((key) => {
        this.setCustomProperty(key, this.getOrderProperties[key]);
      });
    },

    recordOrderFormSubmission() {
      this.recordAction('ORDER FORM SUBMITTED', this.getOrderProperties);
      this.recordOrderProperties();
    },

    recordPaymentAttemptFailed() {
      this.recordAction('PAYMENT ATTEMPT FAILED', { paymentType: useOrderFormStore().getPaymentObject?.pspTypeCode });
    },

    recordPaymentInitFailed() {
      this.recordAction('PAYMENT INITIALISATION FAILED', { paymentType: useOrderFormStore().getPaymentObject?.pspTypeCode });
    },

    recordPaymentFailed() {
      this.recordAction('PAYMENT FAILED', { paymentType: useOrderFormStore().getPaymentObject?.pspTypeCode });
    },

    recordPaymentSuccess() {
      this.recordAction('PAYMENT SUCCESS', { paymentType: useOrderFormStore().getPaymentObject?.pspTypeCode });
    },

    recordError(errorCode, errorMessage, traceId) {
      this.recordAction('ERROR RENDERED', {
        code: errorCode,
        message: errorMessage,
        traceId,
      });

      if (traceId) {
        this.setCustomProperty('errorTraceId', traceId);
      }
    },
  },
  getters: {
    getActions: (state) => state.actions,
    getCustomerKey: (state) => state.customerKey,
    getOrderKey: (state) => state.orderKey,
    getCustomProperties: (state) => state.customProperties,
    getOrderProperties: () => {
      let payload = {};
      const formPayload = useOrderFormStore().getActiveStore.getFormPayload;

      if (formPayload) {
        payload = {
          fiatType: formPayload.fiatType,
          coinType: formPayload.coinType,
          blockchain: formPayload.blockchain,
          payment: formPayload.payment,
          paymentType: useOrderFormStore().getPaymentObject?.pspTypeCode,
          orderType: useOrderFormStore().getOrderType,
        };
      }
      return payload;
    },
  },
});
